
<ul style="list-style: none;" *ngIf="topic.subtopics.length>0">
    <li *ngFor="let subtopic of topic.subtopics;">
        <span>
        <a [routerLink]="['/study/material/card/',subtopic['id']]">
            <i class="fa fa-square text-primary"></i>
            {{subtopic.name}}
        </a>
        </span>

    </li>

</ul>

